import { Admin, ExportFormat, IDiscriminator } from '../../../shared';

export interface IReportJurisdiction {
  'level': number,
  'levelLabel': string,
  'rank': number,
  'sortOrder': number,
  'restOf': boolean,
  'dimensionType': number,
  'code': string,
  'label': string,
  'language': number
}
export interface IComparisonDropdownResponse extends IDiscriminator {
  jurisdictionList: { [key: string] : IReportJurisdiction},
  genderList: {[key: string] : string},
  raceList: {[key: string] : string},
}

export interface ISelectable {
  isSelected?: boolean;
}

export interface IJurisdiction extends ISelectable {
  code: string,
  value: IReportJurisdiction
}

export interface IGender  extends ISelectable{
  code: number,  value: string
}

export interface IRace  extends ISelectable{
  code: number,  value: string
}


export interface ComparisonReportProps {
  admin: Admin;
  setReportOnScreen: React.Dispatch<React.SetStateAction<boolean>>;
  printSignal: boolean;
  exportSignal: ExportFormat;
}

export interface IComparisonReportRowCell {
  stringValue: string;
  dataValue: number;
  rowSpan: number;
  colSpan: number;
}

export interface IComparisonReportRow {
  rowCells: IComparisonReportRowCell[];
  rowType: number;
}

export interface IFootnote {
  'symbol': string;
  footnoteText: string;
}

export interface INote {
  'symbol': string;
  noteText: string;
}

export interface IComparisonReportHeaderInfo {
  [key: string]: string;
}

export interface IComparisonReportData {
  footnotes: IFootnote[];
  notes: string[];
  rows: IComparisonReportRow[];
  headerInfo: IComparisonReportHeaderInfo;
}

export interface IComparisonReport {
  reportDataExists: boolean;
  reportData: IComparisonReportData[];
}

export interface IComparisonReportResponse extends IDiscriminator {
  comparisonReport: IComparisonReport;
}

// must change if column order changes or columns added or removed
export const SEQUENCE_COLUMN = 0;
export const DESCRIPTION_COLUMN = 1;
export const SCORE_COLUMN = 2;
export const RESPONSE_COLUMN = 3;

export const COLUMN_MAPPING: { [key: number]: number } = {
  0: SEQUENCE_COLUMN,
  1: DESCRIPTION_COLUMN,
  2: SCORE_COLUMN,
  3: RESPONSE_COLUMN,
};
